// API Client for the Horizon Protocol frontend
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

export const apiClient = {
  // Base fetch method with error handling
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // Check if response is empty (no content)
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return {}; // Return empty object for empty responses
      }
      
      // Check if response has content before parsing as JSON
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await response.json();
      } else {
        // For non-JSON responses, return text or empty object
        const text = await response.text();
        return text ? text : {};
      }
      
    
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  },

  // GET request helper
  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  },

  // POST request helper
  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // PUT request helper
  async put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  // DELETE request helper
  async delete(endpoint) {
    return this.request(endpoint, { method: 'DELETE' });
  }
};